import TextField, { StandardTextFieldProps } from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import MUIAutocomplete from '@mui/material/Autocomplete';

interface AutocompleteOption {
  label: string;
  value: string;
  category?: string;
}

interface AutocompleteEvent {
  target: { value: string | null };
}

interface AutocompleteProps {
  options: AutocompleteOption[];
  groupBy?: (option: AutocompleteOption) => string;
  onChange?: (e: AutocompleteEvent) => void;
}

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    fontSize: '14px',
  },
}));

const CustomAutocomplete = (props: AutocompleteProps & StandardTextFieldProps) => {
  const { options, groupBy, onChange, ...others } = props;
  return (
    <MUIAutocomplete
      disablePortal
      renderInput={params => <CustomTextField {...others} {...params} />}
      options={options}
      groupBy={groupBy}
      onChange={(event: any, newValue: AutocompleteOption | null) =>
        onChange && onChange({ target: { value: newValue?.value || null } })
      }
    />
  );
};

export const Autocomplete = styled(CustomAutocomplete)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
